// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".giveaway-floating-button[data-v-4d0bbe70]{height:42px;background-color:#2797ff}@media(min-width:0)and (max-width:767px){.giveaway-floating-button[data-v-4d0bbe70]{height:56px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
